<template>
  <div id="SearchIndexZh" class="SearchIndexZh">
    <div class="searchDiv">
      <div class="class_Box">
        <div class="class_Item" v-if="typeclassList.includes(1)">
          <!--          <p class="title_model">书籍</p>-->
          <div
              :class="item.components==Components&&item.typeClass==type_class&&item.key==key_class&&item.value==value_class?'active':'label'"
              v-for="(item,index) in list_1" :key="index" @click="getType(item)">
            {{ item.titlelang.zh }}
          </div>


<!--          <Select ref="culture_select" @on-change="getCulturalClass" transfer-class-name="transfer_index_search"-->
<!--                  label-in-value class="labelSub"-->
<!--                  v-model="culture_id" @on-clear="onClear"-->
<!--                  clearable filterable-->
<!--                  placeholder="文化分类">-->
<!--            <Option v-for="(item,index) in CulturalClassListZh" :value="item.value" :key="index">-->
<!--              {{ item.text ? item.text.trim() : '' }}-->
<!--            </Option>-->
<!--          </Select>-->

<!--          <Select ref="resour_select" @on-change="getResourClass" transfer-class-name="transfer_index_search"-->
<!--                  label-in-value class="labelSub"-->
<!--                  v-model="resourceclass_id" clearable @on-clear="onClear"-->
<!--                  filterable-->
<!--                  placeholder="资源分类">-->
<!--            <Option v-for="(item,index) in ResourceClassListZh" :value="item.value" :key="index">-->
<!--              {{ item.text ? item.text.trim() : '' }}-->
<!--            </Option>-->
<!--          </Select>-->

          <div style="clear: both"></div>
        </div>
        <div class="class_Item" v-if="typeclassList.includes(8)">
          <div :class="item.components==Components&&item.typeClass==type_class?'active':'label'"
               v-for="(item,index) in list_8" :key="index" @click="getType(item)">
            {{ item.titlelang.zh }}
          </div>
          <div v-if="!untype&&$route.path!='/zhver'&&type_class==8" class="left_right left_left_hovr aqt_lang_mn"
               style="color:#FFB600;background: var(--themeColor);width: 34px;height: 34px" @click="getMore(true)">
            <i class="iconfont icondouble-arrow-left-full"></i>
          </div>
          <div v-if="untype&&$route.path!='/zhver'&&type_class==8" class="left_right left_right_hovr aqt_lang_mn"
               style="color:var(--themeColor);width: 34px;height: 34px" @click="getMore(false)">
            <i class="iconfont icondouble-arrow-right-full"></i>
          </div>
          <div style="clear: both"></div>
        </div>
      </div>

      <div v-if="($route.path=='/SearchIndexZh'&&type_class!=8)||$route.path=='/zhver'" class="search_Box">
        <div class="textareadiv titlefont"
             :style="{width:type_class&&$route.path!='/zhver'?(key_class=='book_type'?'calc(100% - 19rem)':'calc(100% - 12rem)'):(key_class=='book_type'?'calc(100% - 14rem)':'calc(100% - 6rem)')}">
        <textarea @keydown="getFsong($event,'other')" v-model="searchContent"
                  @blur="blurSect"></textarea>
        </div>
        <div v-if="key_class=='book_type'" class="icon_s"  @click="geTree()" style="margin-right: 0">
          <Tooltip content="分类数据" placement="bottom">
            <Icon type="ios-list" size="38"/>
          </Tooltip>
        </div>
        <div class="icon_s" @click="getSearch(true)">
          <Icon type="ios-search"/>
        </div>


        <div v-if="!untype&&$route.path!='/zhver'&&type_class" class="left_right left_left_hovr aqt_lang_mn"
             style="color:#FFB600;background: var(--themeColor)" @click="getMore(true)">
          <i class="iconfont icondouble-arrow-left-full"></i>
        </div>
        <div v-if="untype&&$route.path!='/zhver'&&type_class" class="left_right left_right_hovr aqt_lang_mn"
             style="color:var(--themeColor)" @click="getMore(false)">
          <i class="iconfont icondouble-arrow-right-full"></i>
        </div>

      </div>

    </div>
    <div class="mainDiv" v-if="$route.path!='/zhver'">
      <component v-if="show" :is="isComponents" ref="child" @getToDeatils="getToDeatils" @pushTele="pushTele"
                 @goJournal="goJournal" @getWidth="getWidth"></component>
      <aqt-sidebar-zh v-model="showsidebar" :transfer="true" :title="titleStr" slot="others" :width="50">
        <component class="aqt_no_su" :is="which_to_show" :directoryId="directoryId" :infoId="infoId"></component>
      </aqt-sidebar-zh>
    </div>
    <div class="mainDiv" v-if="key_class=='book_type'">
      <aqt-sidebar-zh v-model="modal1" :transfer="true" :title="titleStr" slot="others" :width="50">
        <component class="aqt_no_su" :treeList="ztclassList" :is="which_to_show" @setReturn="setReturn"></component>
      </aqt-sidebar-zh>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  components: {
    BookDetails: (re) => require(['@/views/Books/ZH/BookDetails.vue'], re),//期刊详情
    SelectTree: resolve => {require(['@/components/ZH/SelectTree.vue'], resolve);},


    JournalDetails: (re) => require(['@/views/Journal/MN/JournalDetails.vue'], re),
    AuthorDetails: (re) => require(['@/views/Author/MN/AuthorDetails.vue'], re),
    NewspapersDetais: (re) => require(['@/views/Newspapers/MN/NewspapersDetais.vue'], re),
    QuestionBankDetails: (re) => require(['@/views/QuestionBank/MN/QuestionBankDetails.vue'], re),

  },
  data() {
    return {
      list_1: [
        {
          titlelang: {
            mn: this.$t('m.book_name'),
            zh: '书名',
          },
          components: 'LayListBooksZh',
          typeClass: 1,
          key: 'name',
          value: ''
        },
        {
          titlelang: {
            mn: this.$t('m.isbn'),
            zh: '书号',
          },
          components: 'LayListBooksZh',
          typeClass: 1,
          key: 'isbn',
          value: ''
        },
        {
          titlelang: {
            mn: this.$t('m.introduce'),
            zh: '简介',
          },
          components: 'LayListBooksZh',
          typeClass: 1,
          key: 'content',
          value: ''
        },
        {
          titlelang: {
            mn: this.$t('m.press'),
            zh: '出版社',
          },
          components: 'LayListBooksZh',
          typeClass: 1,
          key: 'press_name',
          value: ''
        },
        {
          titlelang: {
            mn: this.$t('m.press_time'),
            zh: '出版时间',
          },
          components: 'LayListBooksZh',
          typeClass: 1,
          key: 'publish_date_chu',
          value: ''
        },
        {
          titlelang: {
            mn: this.$t('m.author'),
            zh: '作者',
          },
          components: 'LayListBooksZh',
          typeClass: 1,
          key: 'author',
          value: ''
        },
        {
          titlelang: {
            mn: this.$t('m.gjc'),
            zh: '关键词',
          },
          components: 'LayListBooksZh',
          typeClass: 1,
          key: 'subject',
          value: ''
        },
        {
          titlelang: {
            mn: this.$t('m.chainebookclass'),
            zh: '图书分类',
          },
          components: 'LayListBooksZh',
          typeClass: 1,
          key: 'book_type',
          value: ''
        },
      ],
      list_8: [
        {
          titlelang: {
            mn: this.$t('m.intelligent_translation'),
            zh: '智能翻译',
          },
          components: 'LayIntarTranslateZh',
          typeClass: 8,
          key: 'title',
          value: ''
        },
      ],

      queryList: [
        {
          name: '',
          isbn: '',
          content: '',
          press_name: '',
          publish_date_chu: '',
          author: '',
          culture_id: '',
          resourceclass_id: '',
          press_id: '',
          subject:'',
          book_type:'',
        },
        {
          title: '',
          type: 0,//1.书2.期刊3、报刊、4论文
        },
        {
          type: 1,//1作者 2歌手 3医生 4评委
          name: '',//书名
        },
        {
          title: '',//书名
          class_id: '',//152 谚语 151对联 153谜语
          classify_id: ''
        },
        {
          magazine_id: '',//杂志iD
          magazineclass_id: '',//杂志分类id
          type: 'all',//all 全部期刊列表 全部杂志入口  one树状杂志 当前馆藏杂志
        },
        {
          title: '',
          isnow: '',
        },
        {
          title: "",
          language: '',//开始语言
          conlanguage: '',//结束语言
        },
        {
          title: "",
        }
      ],
      CulturalClassListZh: [],//文化分类列表
      ResourceClassListZh: [],//资源分类列表

      startLangList: [
        {
          alis: 'mn',
          name_lang: {
            mn: this.$t('m._Mongolian'),
            zh: '蒙古语',
          }
        },
        {
          alis: 'zh',
          name_lang: {
            mn: this.$t('m._Chinese'),
            zh: '中文',
          }
        }
      ],//头词语言
      endLangList: [
        {
          alis: 'mn',
          name_lang: {
            mn: this.$t('m._Mongolian'),
            zh: '蒙古文',
          }
        },
        {
          alis: 'zh',
          name_lang: {
            mn: this.$t('m._Chinese'),
            zh: '中文',
          }
        },
        {
          alis: 'en',
          name_lang: {
            mn: this.$t('m._English'),
            zh: '英文',
          }
        }
      ],//解释语言

      culture_id: '',
      resourceclass_id: '',
      startlanguage: '',
      endlanguage: '',

      key_class: '',
      value_class: '',
      type_class: '',
      searchContent: '',
      untype: false,
      Components: '',
      isComponents: '',
      typeclassList: [1, 2, 3, 4, 5, 6, 7, 8],
      show: false,

      showsidebar: false,
      titleStr: '',
      which_to_show: '',
      infoId: '',
      directoryId: '',

      JournalClass: [],//期刊分类
      InitialListZh: [],//首字母列表
      JournalCond: {
        title: '',
        keyword: '',//关键词
        issn: '',
        editor: '',//主编
        deputy_editor: '',//副主编

        keymn: '',//首字母
        magazineclass_id: '',//分类id
        type: '',//all 全部期刊列表 全部杂志入口  one树状杂志 当前馆藏杂志

        magazine_id: '',//杂志iD
      },
      jmfield: [
        {
          titlelang: {
            mn: this.$t('m.journal_name') + ' / ' + this.$t('m.qishu') + ' / ' + this.$t('m.mazy_autor'),
            zh: '期刊名称',
          },
          key: 'title',
        },
        {
          titlelang: {
            mn: this.$t('m.journal_keyword'),
            zh: '期刊关键词',
          },
          key: 'keyword'
        },
        {
          titlelang: {
            mn: 'ISSN',
            zh: 'ISSN',
          },
          key: 'issn'
        },
        {
          titlelang: {
            mn: this.$t('m.editor'),
            zh: '主编',
          },
          key: 'editor'
        },
        {
          titlelang: {
            mn: this.$t('m.fu_editor'),
            zh: '副主编',
          },
          key: 'deputy_editor'
        },
      ],
      mzfield: [
        {
          titlelang: {
            mn: this.$t('m.mazy_title'),
            zh: '杂志名称',
          },
          key: 'title'
        },
        {
          titlelang: {
            mn: 'ISSN',
            zh: 'ISSN',
          },
          key: 'issn'
        },
      ],
      fieldKey: 'title',//期刊/杂志检索时的key
      keymnId: '',//首字母
      magazineclassId: '',//分类id

      modal1: false,
    }
  },
  methods: {
    //选择类型
    getType(item) {
      let that = this
      if(item.components!=that.Components){
        that.getWidth()
      }
      that.key_class = item.key
      that.value_class = item.value
      that.type_class = item.typeClass
      that.Components = item.components

      that.culture_id = ''
      that.resourceclass_id = ''
      that.startlanguage = ''
      that.endlanguage = ''
      if (that.$refs.culture_select) {
        that.$refs.culture_select.setQuery(null)
      }
      if (that.$refs.resour_select) {
        that.$refs.resour_select.setQuery(null)
      }

      if (that.$refs.StartLanguage_select) {
        that.$refs.StartLanguage_select.setQuery(null)
      }
      if (that.$refs.EndLanguage_select) {
        that.$refs.EndLanguage_select.setQuery(null)
      }
      const emptyObj = Object.keys(that.queryList[that.type_class - 1]).reduce((obj, key) => {
        if (that.type_class == 5 && key == 'type' && that.Components == 'LayPeriodicalJournal') {
          obj[key] = 'one';
        } else {
          obj[key] = '';
        }
        return obj;
      }, {});
      that.queryList[that.type_class - 1] = {...emptyObj};
      if ((that.type_class == 6 && that.key_class == 'isnow')
          || (that.type_class == 5 && (that.Components == 'LayAllJournalList' || that.Components == 'LayPeriodicalJournal'))
          || that.type_class == 8
      ) {

        that.searchContent = ''
        that.fieldKey = 'title'
        const emptyObj = Object.keys(that.JournalCond).reduce((obj, key) => {
          if (key == 'magazine_id') {

          } else {
            obj[key] = '';
          }

          return obj;
        }, {});
        that.JournalCond = {...emptyObj};
        that.keymnId = ''//首字母
        if (that.Components == 'LayAllJournalList') {
          that.magazineclassId = item.value//分类id
          that.JournalCond.magazineclass_id = item.value
        } else {
          that.magazineclassId = ''
        }
        that.getSearch()
      }
    },
    blurSect(data) {
      // this.searchContent = this.$getOnBlur(data.target.value)
      this.searchContent = data.target.value
    },
    //解决textarea回车换行不出发时间
    getFsong(e, type) {
      if (e.keyCode == 13 && e.ctrlKey) {
        document.getElementById("a").value += "\n";
      } else if (e.keyCode == 13) {
        // 避免回车键换行
        e.preventDefault();
        // 下面写你的发送消息的代码
        if (type == 'other') {
          this.getSearch(true)
        } else if (type == 'jm') {
          this.getJournalSearch(true)
        }

      }

    },
    //点击搜索按钮
    getSearch(isTip = false) {
      let that = this
      if (isTip) {
        if (!that.searchContent) {
          that.$Message.warning({
            render: h => {
              return h('span',{
                style: {
                  writingMode: 'vertical-lr'
                }
              },  '请输入要搜索的内容')
            }
          });
          return;
        }
      }

      if (!that.type_class) {
        that.$Message.warning({
          render: h => {
            return h('span', {
              style: {
                writingMode: 'vertical-lr'
              }
            }, '请选择搜索类型')
          }
        });
        return
      }
      if (that.type_class == 7 && !that.startlanguage) {
        that.$Message.warning({
          render: h => {
            return h('span', {
              style: {
                writingMode: 'vertical-lr'
              }
            }, '请选择头词语言')
          }
        });
        return;
      }
      if (!that.searchContent && that.key_class != 'isnow' && that.Components != 'LayAllJournalList'
          && that.Components != 'LayPeriodicalJournal' && that.Components != 'LayIntarTranslateZh') {
        that.$Message.warning({
          render: h => {
            return h('span', {
              style: {
                writingMode: 'vertical-lr'
              }
            }, '请输入要搜索的内容')
          }
        });
        return
      }


      that.showsidebar = false//关闭详情弹框
      if (that.$route.path == '/zhver') {
        let query = {
          key_class: that.key_class,
          value_class: that.value_class,
          type_class: that.type_class,
          Components: that.Components,
          searchContent: that.searchContent,
          startlanguage: that.startlanguage,
          endlanguage: that.endlanguage
        }
        that.$router.push({
          path: '/SearchIndexZh',
          query: {
            lib_type: sessionStorage.getItem('gcm'),
            data: that.$crypto.set(JSON.stringify(query)),
          }
        })
        that.$loginPd()
      } else {
        that.isComponents = that.Components
        that.show = true
        if (that.type_class == 1) {
          const emptyObj = Object.keys(that.queryList[that.type_class - 1]).reduce((obj, key) => {
            if (that.type_class == 5 && key == 'type' && that.Components == 'LayPeriodicalJournal') {
              obj[key] = 'one';
            } else {
              obj[key] = '';
            }
            return obj;
          }, {});
          if (that.key_class == 'culture_id' || that.key_class == 'resourceclass_id') {
            that.queryList[that.type_class - 1] = {...emptyObj, [that.key_class]: that.value_class};
          } else {
            that.queryList[that.type_class - 1] = {...emptyObj, [that.key_class]: that.searchContent};
          }
        } else if (that.type_class == 2) {
          that.queryList[that.type_class - 1][that.key_class] = that.value_class
          that.queryList[that.type_class - 1].title = that.searchContent
        } else if (that.type_class == 3) {
          that.queryList[that.type_class - 1][that.key_class] = that.searchContent
          that.queryList[that.type_class - 1].type = 1
        } else if (that.type_class == 4) {
          if (that.key_class == 'class_id') {
            that.queryList[that.type_class - 1][that.key_class] = that.value_class
            that.queryList[that.type_class - 1].title = that.searchContent
          } else {
            that.queryList[that.type_class - 1][that.key_class] = that.searchContent
          }
        } else if (that.type_class == 5) {
          // if (that.Components == 'LayListJournal') {
          //   that.queryList[that.type_class - 1][that.key_class] = that.searchContent
          // } else
          if (that.Components == 'LayAllJournalList') {
            that.queryList[that.type_class - 1].title = ''
            that.queryList[that.type_class - 1][that.key_class] = that.value_class
          } else if (that.Components == 'LayPeriodicalJournal') {
            that.queryList[that.type_class - 1][that.key_class] = that.searchContent
          }
        } else if (that.type_class == 6) {
          if (that.key_class == 'title') {
            that.queryList[that.type_class - 1][that.key_class] = that.searchContent
            that.queryList[that.type_class - 1].isnow = ''
          } else {
            that.queryList[that.type_class - 1].isnow = true
            that.queryList[that.type_class - 1].title = that.searchContent
          }
        } else if (that.type_class == 7) {
          that.queryList[that.type_class - 1].title = that.searchContent
          that.queryList[that.type_class - 1].language = that.startlanguage
          that.queryList[that.type_class - 1].conlanguage = that.endlanguage
        }
        setTimeout(function () {
          that.$refs.child.ParentCom(that.queryList[that.type_class - 1]);
          that.$loginPd()
        }, 500)

      }
    },


    //点击期刊搜索
    getJournalSearch(isTip = false) {
      let that = this
      if (isTip) {
        if (!that.searchContent) {
          that.$Message.warning({
            render: h => {
              return h('span',{
                style: {
                  writingMode: 'vertical-lr'
                }
              },  '请输入要搜索的内容')
            }
          });
          return;
        }
        if (!that.fieldKey) {
          that.$Message.warning({
            render: h => {
              return h('span',{
                style: {
                  writingMode: 'vertical-lr'
                }
              },  '请选择搜索类型')
            }
          });
          return
        }
      }

      that.JournalCond[that.fieldKey] = that.searchContent


      setTimeout(function () {
        if (that.Components == 'LayPeriodicalJournal') {
          that.JournalCond.type = 'one'
        }
        that.$refs.child.ParentCom(that.JournalCond);
        that.$loginPd()
      }, 500)
    },
    //期刊杂志选择检索类型
    onField(val) {
      let that = this
      const emptyObj = Object.keys(that.JournalCond).reduce((obj, key) => {
        if (key == 'keymn') {
          obj[key] = that.keymnId;
        } else if (key == 'magazineclass_id') {
          obj[key] = that.magazineclassId;
        } else if (key == 'magazine_id') {
          obj[key] = that.queryList[that.type_class - 1].magazine_id
        } else if (key == 'type') {
          if (that.Components == 'LayPeriodicalJournal') {
            obj[key] = 'one'
          } else {
            obj[key] = that.queryList[that.type_class - 1].type
          }

        } else {
          obj[key] = '';
        }

        return obj;
      }, {});
      that.JournalCond = {...emptyObj};
    },
    //选择期刊、杂志分类
    getJmType(item, type) {
      let that = this
      if (type == 'class') {
        if (item.magazineclass_id == that.magazineclassId && ((that.Components != 'LayAllJournalList')
            || (that.Components == 'LayAllJournalList' && that.value_class == 0))) {
          that.magazineclassId = ''
          that.JournalCond.magazineclass_id = ''
        } else {
          that.magazineclassId = item.magazineclass_id
          that.JournalCond.magazineclass_id = item.magazineclass_id
        }
      } else if (type == 'keymn') {
        if (item.id == that.keymnId) {
          that.keymnId = ''
          that.JournalCond.keymn = ''
        } else {
          that.keymnId = item.id
          that.JournalCond.keymn = item.id
        }
      }

      that.getJournalSearch()

    },

    //分类查看更多
    getMore(untype) {
      let that = this
      that.untype = untype
      if (untype) {
        that.typeclassList = [that.type_class * 1]
      } else {
        that.typeclassList = [1, 2, 3, 4, 5, 6, 7, 8]
      }
      this.getWidth()
    },
    //计算宽度
    getWidth() {
      let _this = this
      _this.$nextTick(() => {
        const searchDivindex = document.querySelectorAll('.searchDiv')
        const boxindex = document.querySelectorAll('.class_Box');
        var sum = 0
        for (let i = 0; i < boxindex[0].children.length; i++) {
          sum += boxindex[0].children[i].offsetHeight
          boxindex[0].style.maxHeight = sum + 'px'
        }
        const boxJmindex = document.querySelectorAll('.class_jm_Box');
        if (boxJmindex && boxJmindex.length) {
          var jmbox = 0
          for (let i = 0; i < boxJmindex[0].children.length; i++) {
            jmbox += boxJmindex[0].children[i].offsetHeight
            boxJmindex[0].style.maxHeight = jmbox + 'px'
          }
          searchDivindex[0].style.maxHeight = (boxindex[0].clientHeight + 80 + boxJmindex[0].clientHeight) + 'px'
        } else {
          searchDivindex[0].style.maxHeight = (boxindex[0].clientHeight + (_this.Components == 'LayIntarTranslateZh'?10:60)) + 'px'
        }

        if (_this.$route.path != '/zhver') {
          const SearchIndexZh = document.querySelectorAll('.SearchIndexZh')
          const searchmainDiv = document.querySelectorAll('.mainDiv')
          searchmainDiv[0].style.maxHeight = (SearchIndexZh[0].clientHeight - searchDivindex[0].clientHeight - 20) +'px'
        }
      })
    },
    //点击文化分类
    getCulturalClass(Option) {
      let that = this
      if (!Option) {
        return
      }
      that.searchContent = Option.label
      that.key_class = 'culture_id'
      that.value_class = Option.value
      that.type_class = 1
      that.Components = 'LayListBooksZh'
      that.resourceclass_id = ''
      if (that.$refs.resour_select) {
        that.$refs.resour_select.setQuery(null)
      }
      if (that.$refs.StartLanguage_select) {
        that.$refs.StartLanguage_select.setQuery(null)
      }
      if (that.$refs.EndLanguage_select) {
        that.$refs.EndLanguage_select.setQuery(null)
      }
    },
    //点击经典分类
    getResourClass(Option) {
      let that = this
      if (!Option) {
        return
      }
      that.searchContent = Option.label
      that.key_class = 'resourceclass_id'
      that.value_class = Option.value
      that.type_class = 1
      that.Components = 'LayListBooksZh'
      that.culture_id = ''
      if (that.$refs.culture_select) {
        that.$refs.culture_select.setQuery(null)
      }
      if (that.$refs.StartLanguage_select) {
        that.$refs.StartLanguage_select.setQuery(null)
      }
      if (that.$refs.EndLanguage_select) {
        that.$refs.EndLanguage_select.setQuery(null)
      }
    },
    //获取文化分类
    queryDataCulture() {
      const _this = this
      let con = {
        slug: 'all',//文化类型标识，全部传all
      }
      _this.$httpsencrypt.post(`api/base/v3/culture/slugfind`, con)
          .then(val => {
            _this.CulturalClassListZh = []
            if (val.code == 200 && val.data.length) {
              _this.handelSlugData(val.data, ' ');
            } else {
              _this.CulturalClassListZh = []
            }
            _this.$store.commit('SET_CulturalClassListZh', _this.CulturalClassListZh)
          }).catch(err => {
      })
    },
    /************************************************************
     *
     * 处理书籍分类和文化分类的数据格式
     *
     ************************************************************/
    handelSlugData(data, label, type = null) {
      const title = label
      data.map((el, ind) => {
        let kk = {
          text: el.name_lang.zh ? `${title} ${el.name_lang.zh}` : `${title} ${el.name_lang.mn}`,
          value: type ? el.book_category_id : el.culture_type_id,
        }
        this.CulturalClassListZh.push(kk)
        let label = `${title}——`
        if (el.child.length !== 0) this.handelSlugData(el.child, label, type)
      })
    },
    //获取经典分类
    queryClassicCulture() {
      const _this = this
      _this.ResourceClassListZh = []
      let cond = {
        type: 'resourceclass'
      }
      _this.$httpsencrypt.post(`api/web/v3/bookdatadictionary/index`, cond)
          .then(val => {
            if (val.code == 200 && val.data.length) {
              val.data.forEach(it => {

                _this.ResourceClassListZh.push({
                  text: it.name_lang ? (it.name_lang.mn || it.name_lang.zh) : '',
                  // value: it.parameter.length ? it.parameter[0].val ? it.parameter[0].val : '' : '',
                  value: it.book_datadictionary_id,
                })
              })
              let yt = {
                text: '地方文献',
                value: 335,
              }
              _this.ResourceClassListZh = _this.ResourceClassListZh.concat(yt)
            } else {
              _this.ResourceClassListZh = []
            }
            _this.$store.commit('SET_ResourceClassListZh', _this.ResourceClassListZh)
          }).catch(err => {
        _this.ResourceClassListZh = []
      })
    },
    //  获取期刊分类
    getPeriodical() {
      const _this = this
      _this.$httpsencrypt.post(`api/web/v3/magazineclass/index`)
          .then(val => {
            if (val.code == 200 && val.data.length) {
              _this.$store.commit('SET_PeriodicalClassZh', val.data)
              _this.JournalClass = val.data
              val.data.forEach((item, index) => {
                _this.list_5.push({
                  titlelang: item.titlelang,
                  components: 'LayAllJournalList',
                  typeClass: 5,
                  key: 'magazineclass_id',
                  value: item.magazineclass_id
                })
              })
              _this.list_5.push({
                titlelang: {
                  mn: _this.library_infor && _this.library_infor.name_lang ? ((_this.library_infor.name_lang.mn || _this.library_infor.name_lang.zh)) : '',
                  zh: _this.library_infor && _this.library_infor.name_lang ? ((_this.library_infor.name_lang.zh || _this.library_infor.name_lang.mn)) : '',
                },
                components: 'LayPeriodicalJournal',
                typeClass: 5,
                // key: 'title',
                key: '',
                value: ''
              })
            } else {
              _this.$store.commit('SET_PeriodicalClassZh', [])
              _this.JournalClass = []
            }
            _this.$nextTick(() => {
              setTimeout(function () {
                _this.getWidth()
              }, 500)
            })
          }).catch(err => {
      })
    },
    //获取首字母
    getInitialList() {
      const _this = this
      _this.$http.get(`api/web/v1/Magazine/keywordlist?type=mn`)
          .then(val => {
            if (val.info.code == 200 && val.data.length) {
              _this.$store.commit('SET_InitialListZh', val.data)
              _this.InitialListZh = val.data
            } else {
              _this.$store.commit('SET_InitialListZh', [])
              _this.InitialListZh = []
            }
            _this.$nextTick(() => {
              setTimeout(function () {
                _this.getWidth()
              }, 500)
            })
          }).catch(err => {
      })
    },
    //书籍列表点击出版社进行检索
    pushTele(val) {
      let that = this
      that.showsidebar = false//关闭详情弹框
      that.searchContent = val.data
      that.key_class = 'press_name'
      that.value_class = ''
      that.type_class = 1
      that.Components = 'LayListBooksZh'
      that.isComponents = that.Components
      that.culture_id = ''
      that.resourceclass_id = ''
      if (that.$refs.culture_select) {
        that.$refs.culture_select.setQuery(null)
      }
      if (that.$refs.resour_select) {
        that.$refs.resour_select.setQuery(null)
      }

      const emptyObj = Object.keys(that.queryList[that.type_class - 1]).reduce((obj, key) => {
        if (that.type_class == 5 && key == 'type' && that.Components == 'LayPeriodicalJournal') {
          obj[key] = 'one';
        } else {
          obj[key] = '';
        }
        return obj;
      }, {});
      that.queryList[that.type_class - 1] = {...emptyObj, 'press_id': val.id};
      setTimeout(function () {
        that.$refs.child.ParentCom(that.queryList[that.type_class - 1]);
        that.$loginPd()
      }, 500)
    },
    //进入期刊列表
    goJournal(val) {
      let that = this
      that.showsidebar = false//关闭详情弹框
      that.searchContent = ''
      that.key_class = 'title'
      that.value_class = ''
      that.type_class = 5
      that.Components = 'LayListJournal'
      that.isComponents = that.Components

      that.queryList[that.type_class - 1].magazine_id = val.id
      that.queryList[that.type_class - 1].title = ''
      that.queryList[that.type_class - 1].type = val.type


      that.searchContent = ''
      that.fieldKey = 'title'
      const emptyObj = Object.keys(that.JournalCond).reduce((obj, key) => {
        if (key == 'magazine_id') {
          obj[key] = val.id
        } else if (key == 'type') {
          obj[key] = val.type
        } else {
          obj[key] = '';
        }

        return obj;
      }, {});
      that.JournalCond = {...emptyObj};
      that.keymnId = ''//首字母
      that.magazineclassId = ''

      that.JournalCond.type = val.type
      that.JournalCond.magazine_id = val.id


      setTimeout(function () {
        that.$refs.child.ParentCom(that.JournalCond);
        that.$loginPd()
      }, 500)
    },
    //  进到首页时恢复到原来的样子
    getClear() {
      let that = this
      that.untype = false
      that.typeclassList = [1, 2, 3, 4, 5, 6, 7, 8]
      that.key_class = ''
      that.value_class = ''
      that.type_class = ''
      that.Components = ''
      that.searchContent = ''
      that.culture_id = ''
      that.resourceclass_id = ''
      that.startlanguage = ''
      that.endlanguage = ''
      if (that.$refs.culture_select) {
        that.$refs.culture_select.setQuery(null)
      }
      if (that.$refs.resour_select) {
        that.$refs.resour_select.setQuery(null)
      }
      if (that.$refs.StartLanguage_select) {
        that.$refs.StartLanguage_select.setQuery(null)
      }
      if (that.$refs.EndLanguage_select) {
        that.$refs.EndLanguage_select.setQuery(null)
      }
      that.$nextTick(() => {
        setTimeout(function () {
          that.getWidth()
        }, 500)
      })
    },

    onStartSelect() {
      let that = this
      that.key_class = 'language'
      that.value_class = ''
      that.type_class = 7
      that.Components = 'LayTranslate'
      if (that.$refs.culture_select) {
        that.$refs.culture_select.setQuery(null)
      }
      if (that.$refs.resour_select) {
        that.$refs.resour_select.setQuery(null)
      }
    },
    onEndSelect() {
      let that = this
      that.key_class = 'conlanguage'
      that.value_class = ''
      that.type_class = 7
      that.Components = 'LayTranslate'
      if (that.$refs.culture_select && that.culture_id) {
        that.$refs.culture_select.setQuery(null)
      }
      if (that.$refs.resour_select) {
        that.$refs.resour_select.setQuery(null)
      }
    },

    //进入详情
    getToDeatils(val, components) {
      let that = this
      that.which_to_show = components
      that.showsidebar = true
      that.titleStr = '详情'
      that.infoId = val.id
      that.directoryId = val.directory_id
      that.$loginPd()
    },

    //获取语言
    getLang() {
      const _this = this
      let con = {
        type: 'fylanguage',//语言列表，全部传all
      }
      _this.$httpsencrypt.post(`api/web/v3/bookdatadictionary/index`, con)
          .then(val => {
            this.$store.commit('SET_langNewArrZh', val.data)
          }).catch(err => {
      })
    },

    //下拉框点击清空按钮事件
    onClear() {
      let that = this
      that.searchContent = ''
      that.key_class = ''
      that.value_class = ''
      that.type_class = ''
      that.Components = ''
    },

    geTree(){
      this.which_to_show = 'SelectTree'
      this.modal1 = true
      this.titleStr = '选择分类'
    },
    setReturn(val) {
      let that = this
      let newVal = val.join(' ')
      that.searchContent = that.searchContent + ' ' + newVal
      that.modal1 = false
    },
  },
  computed: {
    // 馆藏id
    library_id() {
      let vv = localStorage.getItem("theme_color") ?
          JSON.parse(this.$crypto.get(localStorage.getItem("theme_color"))).library_id ?
              JSON.parse(this.$crypto.get(localStorage.getItem("theme_color"))).library_id : 28 : 28
      return vv
    },
    member_id() {
      let vv = localStorage.getItem("userInfoMemberId") ? JSON.parse(this.$crypto.get(localStorage.getItem("userInfoMemberId"))).member_id : ''
      return vv
    },
    library_infor: {
      get: function () {
        let myDate = localStorage.getItem("theme_color") ?
            JSON.parse(this.$crypto.get(localStorage.getItem("theme_color"))) : ''
        return myDate;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    // 中图分类
    ztclassList() {
      return this.$store.getters.ztclass
    },
  },
  created() {
    let that = this
    that.$loginPd()
    if (this.$store.getters.CulturalClassListZh.length) {
      this.CulturalClassListZh = this.$store.getters.CulturalClassListZh
    } else {
      this.queryDataCulture()
    }
    if (this.$store.getters.ResourceClassListZh.length) {
      this.ResourceClassListZh = this.$store.getters.ResourceClassListZh
    } else {
      this.queryClassicCulture()
    }

    // if (this.$store.getters.PeriodicalClassZh.length) {
    //   this.JournalClass = this.$store.getters.PeriodicalClassZh
    //   this.$store.getters.PeriodicalClassZh.forEach((item, index) => {
    //     this.list_5.push({
    //       titlelang: item.titlelang,
    //       components: 'LayAllJournalList',
    //       typeClass: 5,
    //       key: 'magazineclass_id',
    //       value: item.magazineclass_id
    //     })
    //   })
    //   this.list_5.push({
    //     titlelang: {
    //       mn: this.library_infor && this.library_infor.name_lang ? ((this.library_infor.name_lang.mn || this.library_infor.name_lang.zh)) : '',
    //       zh: this.library_infor && this.library_infor.name_lang ? ((this.library_infor.name_lang.zh || this.library_infor.name_lang.mn)) : '',
    //     },
    //     components: 'LayPeriodicalJournal',
    //     typeClass: 5,
    //     // key: 'title',
    //     key: '',
    //     value: ''
    //   })
    //   this.$nextTick(() => {
    //     setTimeout(function () {
    //       that.getWidth()
    //     }, 1000)
    //   })
    //
    // } else {
    //   this.getPeriodical()
    // }
    // if (!that.$store.getters.langNewArrZh.length) {
    //   that.getLang()
    // }
    //
    // if (this.$store.getters.InitialListZh.length) {
    //   this.InitialListZh = this.$store.getters.InitialListZh
    // } else {
    //   this.getInitialList()
    // }


    if (this.$route.query && this.$route.query.data) {
      let routerData = JSON.parse(this.$crypto.get(this.$route.query.data))
      this.key_class = routerData.key_class
      this.value_class = routerData.value_class
      this.type_class = routerData.type_class
      this.Components = routerData.Components
      this.searchContent = routerData.searchContent
      this.culture_id = routerData.key_class == 'culture_id' ? routerData.value_class : ''
      this.resourceclass_id = routerData.key_class == 'resourceclass_id' ? routerData.value_class : ''
      this.startlanguage = this.type_class == 7 ? routerData.startlanguage : ''
      this.endlanguage = this.type_class == 7 ? routerData.endlanguage : ''
    }
    if (this.$route.query && this.$route.query.data) {
      let routerData = JSON.parse(this.$crypto.get(this.$route.query.data))
      this.untype = true
      this.typeclassList = routerData.type_class ? [routerData.type_class * 1] : [1, 2, 3, 4, 5, 6, 7, 8]
    } else {
      that.untype = false
      that.typeclassList = [1, 2, 3, 4, 5, 6, 7, 8]
    }
    this.$nextTick(() => {
      setTimeout(function () {
        that.getWidth()
      }, 500)
    })

  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getSearch()
      if (to.query.data && vm.$crypto.get(to.query.data) && JSON.parse(vm.$crypto.get(to.query.data)).type_class) {
        let routerDatatype_class = JSON.parse(vm.$crypto.get(to.query.data)).type_class
        vm.untype = true
        vm.typeclassList = [routerDatatype_class * 1]
      } else {
        vm.untype = false
        vm.typeclassList = [1, 2, 3, 4, 5, 6, 7, 8]
      }

    })
  }


}
</script>

<style lang="less" scoped>
#SearchIndexZh {
  width: 100%;
  height: 100%;
  padding: 20px 10%;

  .searchDiv {
    height: 100%;
    padding: 0 55px;
    padding-bottom: 10px;
    background: #ffffff;
    margin-bottom: 10px;


    .class_Box {
      width: 100%;

      .class_Item {
        height: 100%;
        border-bottom: 1px solid #E6EFFD;
        padding-top: 6px;

        .label {
          height: 34px;
          min-width: 63px;
          padding: 8px;
          border-radius: 4px;
          border: 1px solid var(--themeColor);
          color: #888888;
          font-size: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 6px;
          margin-right: 13px;
          float: left;
          cursor: pointer;
        }

        .active {
          height: 34px;
          min-width: 63px;
          padding: 8px;
          border-radius: 4px;
          border: 1px solid var(--themeColor);
          color: #FFB600;
          background: var(--themeColor);
          font-size: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 6px;
          margin-right: 13px;
          float: left;
          cursor: pointer;
        }

        .label:hover {
          background: #F5F5F5;
        }

        .labelSub {
          height: 34px;
          width: 240px;
          border-radius: 4px;
          font-size: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 6px;
          margin-right: 13px;
          float: left;
          cursor: pointer;
        }

        .title_model {
          height: 34px;
          margin-right: 10px;
          color: #888888;
          font-size: 18px;
          line-height: 34px;
          float: left;
        }

      }
    }


    .class_jm_Box {
      height: 100%;

      .class__jm_Item {
        height: 48px;
        width: 100%;
        border-right: 1px solid #E6EFFD;
        padding-top: 8px;
        overflow-x: auto;
        overflow-y: hidden;

        .labeljm {
          height: 28px;
          min-width: 30px;
          padding: 8px;
          border-radius: 4px;
          border: 1px solid var(--themeColor);
          color: #888888;
          font-size: 14px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 6px;
          margin-left: 13px;
          float: left;
          cursor: pointer;
        }

        .activejm {
          height: 28px;
          min-width: 30px;
          padding: 8px;
          border-radius: 4px;
          border: 1px solid var(--themeColor);
          color: #FFB600;
          background: var(--themeColor);
          font-size: 14px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 6px;
          margin-left: 13px;
          float: left;
          cursor: pointer;
        }

        .labeljm:hover {
          background: #F5F5F5;
        }

        .title_model_jm {
          height: 34px;
          margin-left: 10px;
          color: #888888;
          font-size: 18px;
          line-height: 34px;
          float: left;
        }

      }

      .class__jm_Item::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 12px;
      }

      .class__jm_Item::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(0, 0, 0, 0.2);
      }

      .class__jm_Item::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(0, 0, 0, 0.1);
      }
    }


    .search_Box {
      height: 40px;
      width: 100%;
      margin-top: 6px;
      display: flex;
      justify-content: center;
      align-items: center;

      .textareadiv {
        height: 100%;

        textarea {
          width: 100%;
          height: 100%;
          font-size: 18px;
          display: table-column !important;
          color: #888888;
          background: #F5F5F5;
          text-indent: 1rem;
          resize: none;
          border: none;
          outline: none;
          overflow-x: hidden !important;
          white-space: nowrap;
          line-height: 3.3rem;
          font-weight: unset;
          font-weight: normal;
          font-family: "MGQ8102" !important;
          border-radius: 3px 3px 0 0;
        }

        textarea::-webkit-input-placeholder { /* WebKit browsers */
          line-height: 40px !important;
        }

        textarea:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
          color: #888888;
        }

        textarea::-moz-placeholder { /* Mozilla Firefox 19+ */
          color: #888888;
        }

        textarea:-ms-input-placeholder { /* Internet Explorer 10+ */
          color: #888888;
        }

      }

      .icon_s {
        height: 39px;
        width: 6rem;
        border: 1px solid var(--themeColor);
        background: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        border-radius: 0 0 3px 3px;
        margin: 0 auto;

        i {
          color: var(--themeColor);
          font-size: 28px;
        }
      }

      .icon_s:hover {
        background: var(--themeColor);

        i {
          color: #FFB600;
        }
      }

      .JMlabelSub {
        height: 40px;
        line-height: 40px;
        border-radius: 4px;
        margin-bottom: 1rem;
        font-size: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        float: left;
        cursor: pointer;
      }

    }

    .left_right {
      height: 100%;
      width: 40px;
      padding: 8px;
      border-radius: 4px;
      border: 1px solid var(--themeColor);
      color: #888888;
      font-size: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      margin-right: 10px;
    }

    .left_left_hovr:hover {
      background: #F5F5F5 !important;
      color: var(--themeColor) !important;
    }

    .left_right_hovr:hover {
      color: #FFB600 !important;
      background: var(--themeColor) !important;

    }
  }

  .mainDiv {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    position: relative;
  }

}
</style>

<style lang="less">
#SearchIndexZh {
  //下拉框的样式
  .ivu-select {
    position: relative !important;
  }

  .ivu-select-single .ivu-select-selection {
    width: 100% !important;
    height: 100% !important;
    border: 1px solid var(--themeColor) !important;
  }

  .ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    height: 100% !important;
    color: #FFB600 !important;
  }

  .ivu-select-placeholder {
    color: #888888 !important;
  }

  .ivu-select-arrow {
    color: var(--themeColor) !important;
  }

  .transfer_index_search {
    background: var(--themeColor) !important;
  }

  .ivu-select-item {
    color: #ffffff !important;
  }

  .ivu-select-item-selected, .ivu-select-item-selected:hover {
    background: rgba(255, 255, 255, 0.5) !important;
  }

  .ivu-select-item-focus {
    background: none;
  }

  .ivu-select .ivu-select-item:hover {
    background: rgba(255, 255, 255, 0.3) !important;
    color: #FFB600 !important;
  }

  .ivu-select-selection {
    background: none !important;
    border: 1px solid var(--themeColor) !important;
  }

  .ivu-select-multiple .ivu-select-input {
    color: var(--themeColor) !important;
  }

  .ivu-select-multiple .ivu-select-selection {
    padding: 0 !important;
  }

  .ivu-tag-text {
    color: var(--themeColor) !important;
    font-size: 16px !important;
  }

  .ivu-select-single .ivu-select-input {
    color: var(--themeColor) !important;
    font-size: 18px !important;
  }

  .ivu-select input::-webkit-input-placeholder { /* WebKit browsers */
    position: absolute;
    top: 3px !important;
    color: #888888;
    font-size: 18px !important;
  }


}
</style>
